import type { VoidFunctionComponent } from 'react';

import type { SnippetDetails } from '../../../../../shared/snippets';

import Licenses from './Licenses';
import MatchConfidence from './MatchConfidence';
import PackageSummary from './PackageSummary';

type Props = {
  /**
   * Snippet data.
   */
  snippet: SnippetDetails;
};

/**
 * Details tab for the SnippetDrawer.
 * Displays more details about a given snippet.
 */
const SnippetsDrawerDetails: VoidFunctionComponent<Props> = ({ snippet }) => {
  return (
    <>
      <PackageSummary snippet={snippet} />
      <MatchConfidence snippet={snippet} />
      <Licenses licenses={snippet.licenses} />
    </>
  );
};

export default SnippetsDrawerDetails;
